import { render, staticRenderFns } from "./CardReaderEdit.vue?vue&type=template&id=324404fa&scoped=true"
import script from "./CardReaderEdit.vue?vue&type=script&lang=ts"
export * from "./CardReaderEdit.vue?vue&type=script&lang=ts"
import style0 from "./CardReaderEdit.vue?vue&type=style&index=0&id=324404fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324404fa",
  null
  
)

export default component.exports